import { auth } from 'routes/config';
import { Navigate, Route, Routes } from 'react-router-dom';

import Login from 'containers/Public/Authentication/Login';
import Logout from 'containers/Public/Authentication/Logout';
import EmailVerification from 'containers/Public/Authentication/EmailVerification';

export default function AuthRouter() {
  return (
    <Routes>
      <Route path={auth.login} element={<Login />} />
      <Route path={auth.logout} element={<Logout />} />
      <Route path={auth.emailVerification} element={<EmailVerification />} />
      <Route path='*' element={<Navigate to='/404' replace />} />
    </Routes>
  );
}
